import { ChangeEvent, HTMLInputTypeAttribute, InputHTMLAttributes } from 'react';
import styled from 'styled-components';
import { InputValue } from '../../../interfaces/Element.interfaces';
import { SurveyInputHeader } from '../survey/inputs/SurveyInputHeader';
import { BasicInput } from './BasicInput';

interface BasicInputWithExtrasProps {
  className?: string;
  inputLabel?: string;
  type?: HTMLInputTypeAttribute;
  inputValue: InputValue;
  placeholder: string;
  readonly?: boolean;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  onChange?: (newValue: InputValue) => void;
  children?: JSX.Element;
  isRequired?: boolean;
  isOptional?: boolean;
  onClick?: () => void;
}

export const BasicInputWithExtras = ({
  className,
  type = 'text',
  placeholder,
  inputLabel,
  inputValue,
  readonly: disabled,
  onChange,
  inputProps,
  children,
  isRequired = false,
  isOptional = false,
  onClick,
}: BasicInputWithExtrasProps) => {
  return (
    <>
      {/* TODO: SurveyInputHeader 삭제하고 common/inputs로 옮기기 */}
      {inputLabel && <SurveyInputHeader inputTitle={inputLabel} isRequired={isRequired} isOptional={isOptional} />}
      <InputContainer>
        <BasicInput
          className={className}
          type={type}
          {...inputProps}
          placeholder={placeholder}
          value={inputValue}
          readOnly={disabled}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            if (!onChange) {
              return;
            }
            if (event.target.value) {
              const newValue = event.target.value;
              onChange(newValue);
            } else {
              onChange(undefined);
            }
          }}
          onClick={onClick}
        />
        {children}
      </InputContainer>
    </>
  );
};

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--radius-medium, 8px);
  align-self: stretch;
`;
